// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type BookmarkIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from bookmark.svg
 */
export default function BookmarkIcon(props: BookmarkIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="BookmarkIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M3 0h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1.625.78L8 12.28l-4.375 3.5a1 1 0 0 1-1.62-.668L2 15V1a1 1 0 0 1 1-1m9 12.92V2H4v10.919l3.375-2.7a1 1 0 0 1 1.147-.072l.103.072z"
        />
      </g>
    </svg>
  );
}
